import React, { useEffect } from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import HelpIcon from "@mui/icons-material/Help";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import MapsUgcIcon from "@mui/icons-material/MapsUgc";
import { mainListItems } from "./ListItems";
import Avatar from "./Avatar";
import { Outlet } from "react-router";
import LogoutButton from "../../../utils/LogoutButton";
import logo from "./../../../img/logore.png";
import {
  Link,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import FormEncuesta from "../../../components/portal/formencuesta/FormEncuesta";
import { useSelector } from "react-redux";

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    background: "#212529",
    color: "white",
    width: "240px",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

// Estilos del modal
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "100%", sm: "100%", md: 600, lg: 600 },
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function DashboardTemp({ children }) {

  const { encuestar } = useSelector((state) => state.user);

  // ---------------------------- Estado del Menu ------------------------------ //
  const [open, setOpen] = useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  // ---------------------------- Estado del modal Ayuda ------------------------------ //
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  // ---------------------------- Estado del modal Encuesta ------------------------------ //
  const [openEncuesta, setOpenEncuesta] = useState(false);

  // Funciones para abrir y cerrar el modal
  /*
  const handleClickOpenEncuesta = () => {
    setOpenEncuesta(true);
  };
  */

  const handleCloseEncuesta = () => {
    setOpenEncuesta(false);
  };

  // ---------------------------- ejecucion automatica del modal Encuesta ------------------------------ //

  useEffect(() => {
    if(encuestar === "1"){
      setOpenEncuesta(true);
    }
  }, [encuestar]);

  return (
    <ThemeProvider theme={defaultTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        <Drawer variant="permanent" open={open}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: [1],
            }}
          >
            <IconButton
              edge="end"
              onClick={toggleDrawer}
              sx={{
                ...(!open && { display: "none" }),
                marginLeft: "80%",
              }}
            >
              <ChevronLeftIcon style={{ color: "white" }} />
            </IconButton>

            <IconButton
              edge="center"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
          </Box>

          <Box
            sx={{
              height: "80%",
            }}
          >
            <List component="nav">
              {mainListItems}

              <ListItemButton>
                <ListItemIcon>
                  <MapsUgcIcon style={{ color: "white" }} />
                </ListItemIcon>

                <Link
                  color="inherit"
                  style={{ textDecoration: "none" }}
                  href="/presentarquejas"
                >
                  <ListItemText primary="Sugerencias" />
                </Link>
              </ListItemButton>

              {/*
              <ListItemButton>
                <ListItemIcon>
                  <QuizIcon style={{ color: "white" }} />
                </ListItemIcon>

                <Link
                  color="inherit"
                  style={{ textDecoration: "none" }}
                  onClick={handleClickOpenEncuesta}
                >
                  <ListItemText primary="Encuesta" />
                </Link>
              </ListItemButton>
              */}

              <ListItemButton>
                <ListItemIcon>
                  <SupportAgentIcon style={{ color: "white" }} />
                </ListItemIcon>

                <Link
                  color="inherit"
                  style={{ textDecoration: "none" }}
                  onClick={handleOpenModal}
                >
                  <ListItemText primary="Asistencia" />
                </Link>
              </ListItemButton>

              <ListItemButton>
                <ListItemIcon>
                  <HelpIcon style={{ color: "white" }} />
                </ListItemIcon>

                <Link
                  href="/manual"
                  target="_blank"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  Ayuda
                </Link>
              </ListItemButton>
            </List>
          </Box>

          <Avatar />
          <LogoutButton />
        </Drawer>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <>{children ? children : <Outlet />}</>
        </Box>
        <Box
          sx={{
            display: { xs: "none", sm: "none", md: "flex", lg: "flex" },
          }}
        >
          <Modal
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Box>
                <img
                  src={logo}
                  alt="logo"
                  style={{
                    width: "15%",
                    height: "auto", // Reemplaza con la URL de tu imagen de fondo
                    marginTop: "0px",
                    marginLeft: "0px",
                    position: "absolute",
                  }}
                />
              </Box>

              <Typography
                id="modal-modal-title"
                variant="h5"
                component="h2"
                style={{
                  textAlign: "center",
                  fontSize: 20,
                  fontWeight: "bold",
                }}
              >
                CONTÁCTANOS
              </Typography>
              <Box style={{ with: "100%", marginTop: "40px" }}>
                <Stack
                  spacing={{ xs: 1, sm: 2 }}
                  direction="row"
                  useFlexGap
                  flexWrap="wrap"
                  style={{ marginTop: "20px" }}
                >
                  <Typography
                    id="modal-modal-description"
                    style={{ fontSize: 16, fontWeight: "bold" }}
                  >
                    <CallIcon />
                  </Typography>
                  <Typography>809-621-9999 Opción: 117,125</Typography>
                </Stack>
                <Stack
                  spacing={{ xs: 1, sm: 2 }}
                  direction="row"
                  useFlexGap
                  flexWrap="wrap"
                  style={{ marginTop: "20px" }}
                >
                  <Typography
                    id="modal-modal-description"
                    style={{ fontSize: 16, fontWeight: "bold" }}
                  >
                    <EmailIcon />
                  </Typography>
                  <Typography>cobertura@arsrenacer.com</Typography>
                </Stack>
              </Box>
            </Box>
          </Modal>

          <>
            <FormEncuesta
              openEncuesta={openEncuesta}
              handleCloseEncuesta={handleCloseEncuesta}
            />
          </>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
